// @ts-check

/**
 * Whether one of your own timers is online but not yet following a session,
 * so "Send to device" has something to send to.
 *
 * Only your own timers count either way: a mate's timer in a shared session,
 * or a mate's timer shared with you going on or offline, says nothing about
 * yours. Counting them hid the option as soon as a mate's timer joined.
 *
 * @param {{
 *   ownDeviceIds: Array<number|string>,
 *   presenceByDevice: Record<string, boolean> | null | undefined,
 *   connectedDeviceIds: Array<number|string> | null | undefined,
 * }} args
 * @returns {boolean}
 */
export function ownTimerToSend({ ownDeviceIds, presenceByDevice, connectedDeviceIds }) {
  const following = new Set((connectedDeviceIds || []).map(Number));
  return ownDeviceIds.some(
    (id) => presenceByDevice?.[Number(id)] === true && !following.has(Number(id)),
  );
}
